import { Sparkles } from "lucide-react";

const MainLogo = () =>
    <div className="se-gradient group w-8 h-8 bg-gradient-to-br from-blue-500 to-teal-500 rounded-lg flex items-center justify-center">
        <div className="se-gradient-overlay" />
        <Sparkles className="se-gradient-icon w-5 h-5 text-white" />
    </div>

export default MainLogo;